import React, { useState } from "react";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { doUpdateProfile, doCreateUserWithEmailAndPassword } from "../../../firebase/auth";
import { addRecord } from "../../../firebase/db/users/crud.tsx";
import { subscribeUser } from "../../../firebase/db/stripe/crud.tsx";
import { useAuth } from "../../../contexts/authContext";
import { DangerToast } from "../../partials/toast.tsx";

const Register = () => {
	const navigate = useNavigate();
	const { userLoggedIn } = useAuth();
	// const [firstName, setFirstName] = useState("");
	// const [lastName, setLastName] = useState("");
	const [artistName, setArtistName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setconfirmPassword] = useState("");
	const [isRegistering, setIsRegistering] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [showToast, setShowToast] = useState(Boolean);
	const [toastMessage, setToastMessage] = useState(String);

	const handleToastHide = () => {
		setToastMessage("");
		setShowToast(false);
	};

	const onSubmit = async (e) => {
		e.preventDefault();
		if (password !== confirmPassword) {
			setToastMessage("Error signing up: Password and Password Confirmation must match");
			setShowToast(true);
			return null;
		}
		if (!isRegistering) {
			setIsRegistering(true);
			try {
				doCreateUserWithEmailAndPassword(email, password)
					.then((firebaseUser) => {
						const profile = {
							displayName: artistName
						};
						doUpdateProfile(firebaseUser.user, profile)
							.then(() => {
								const newUser = {
									// first_name: firstName,
									// last_name: lastName,
									artist_name: artistName,
									is_active: true,
									email: firebaseUser.user.email,
									created: new Date(),
									modified: new Date()
								};
								addRecord(firebaseUser.user.uid, newUser);
							})
							.finally(() => {
								subscribeUser(firebaseUser.user.uid).then((url) => {
									console.log("URL: " + JSON.stringify(url));
									if (url) {
										window.location = url;
									} else {
										console.log("Error generating checkout Url");
									}
								});
							});
					})
					.catch((error) => {
						setToastMessage("Error signing up: " + error.code);
						setShowToast(true);
						console.error("Error creating user: " + error.code);
						setIsRegistering(false);
					});
			} catch (error) {
				alert("Error creating user: " + error);
				console.error("Error creating user: " + error);
				setIsRegistering(false);
			}
		}
	};

	return (
		<>
			{/* {userLoggedIn && <Navigate to={"/home"} replace={true} />} */}

			<main className="w-full h-screen flex self-center place-content-center place-items-center">
				<DangerToast showToast={showToast} errorMessage={toastMessage} onHide={handleToastHide} />

				<div className="flex p-8">
					<div class="mr-6">
						<div class="w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
							<h5 class="mb-4 text-xl font-medium text-gray-500 dark:text-gray-400">Starter Plan</h5>
							<div class="flex items-baseline text-gray-900 dark:text-white">
								<span class="text-3xl font-semibold">$</span>
								<span class="text-5xl font-extrabold tracking-tight">15</span>
								<span class="ms-1 text-xl font-normal text-gray-500 dark:text-gray-400">/month</span>
							</div>
							<ul class="space-y-5 my-7">
								<li class="flex items-center">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">1 Artist</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">15GB Cloud storage</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Catalog Management</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Fan Management</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Release Management</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Label Management</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Promoter Management</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Song Share</span>
								</li>
								<li class="flex">
									<svg
										class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
										viewBox="0 0 20 20">
										<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
									</svg>
									<span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">File Transfer</span>
								</li>
							</ul>
							{/* <button
								type="button"
								class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center w-full text-center">
								Choose plan
							</button> */}
						</div>
					</div>
					<div className="w-96 text-gray-400 space-y-5 p-4 shadow-xl border rounded-xl">
						<div className="text-center mb-6">
							<div className="mt-2">
								<h3 className="text-white text-xl font-semibold sm:text-2xl">Join Control Room Now</h3>
							</div>
						</div>
						<form onSubmit={onSubmit} className="space-y-4">
							<div>
								<label className="text-sm font-bold">Artist Name</label>
								<input
									type="text"
									required
									value={artistName}
									onChange={(e) => {
										setArtistName(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border border-gray-400 focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>
							{/* <div>
								<label className="text-sm font-bold">First Name</label>
								<input
									type="text"
									required
									value={firstName}
									onChange={(e) => {
										setFirstName(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border border-gray-400 focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>
							<div>
								<label className="text-sm font-bold">Last Name</label>
								<input
									type="text"
									required
									value={lastName}
									onChange={(e) => {
										setLastName(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border border-gray-400 focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div> */}
							<div>
								<label className="text-sm font-bold">Email</label>
								<input
									type="email"
									autoComplete="email"
									required
									value={email}
									onChange={(e) => {
										setEmail(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border border-gray-400 focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>

							<div>
								<label className="text-sm font-bold">Password</label>
								<input
									disabled={isRegistering}
									type="password"
									autoComplete="new-password"
									required
									value={password}
									onChange={(e) => {
										setPassword(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border border-gray-400 focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>

							<div>
								<label className="text-sm font-bold">Confirm Password</label>
								<input
									disabled={isRegistering}
									type="password"
									autoComplete="off"
									required
									value={confirmPassword}
									onChange={(e) => {
										setconfirmPassword(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border border-gray-400 focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>

							{/* {errorMessage && <span className="text-red-600 font-bold">{errorMessage}</span>} */}

							<button
								type="submit"
								disabled={isRegistering}
								className={`w-full px-4 py-2 text-white font-medium rounded-lg ${
									isRegistering ? "register-button cursor-not-allowed" : "register-button hover:shadow-xl transition duration-300"
								}`}>
								{isRegistering ? "Signing Up..." : "Sign Up"}
							</button>
							<div className="text-sm text-gray-400 text-center">
								Already have an account? {"   "}
								<Link to={"/login"} className="text-center text-gray-400 text-sm hover:underline font-bold">
									Login
								</Link>
							</div>
						</form>
					</div>
				</div>
			</main>
		</>
	);
};

export default Register;
